// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__st5aR","Div":"CustomFadeBox_Div__8A1m-","LargeDiv":"CustomFadeBox_LargeDiv__jneDK"};